<script>

import CommonConstants from '../../common/Constants';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import GenericCustomSelect from './GenericCustomSelect.vue'

export default {
    components: {Dialog, Button, InputText, Checkbox, GenericCustomSelect},
    props: ['item', 'caller'], 
    data(){
        return{
            visible: false,
            model: {}
        }
    },
    mounted(){
    },
    methods: {
        show(){
            this.visible = true;
        },
        closeModal(){
            this.visible=false;
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        }
    }
}

</script>

<style lang="css" scoped>
    .mdc-form-field > label {
        flex-basis: 80px !important;
        margin-right: 10px !important;
    }

  .mdc-text-field,
  .mdc-select {
        min-width: 200px;
  }

  .generic-alert-btn{
      margin: 10px;
  }

</style>

<template>
    <Dialog :header="$t(item.title)" v-model:visible="visible" :modal="true">
        <div class="grid formgrid" >
            <div class="col-12 m-1" v-for="field in item.fields" :key="field.name">
                <div class="field-checkbox  m-3" v-if="field.type == 'boolean'">
                    <Checkbox :id="field.name" v-if="field.type == 'boolean'" v-model="model[field.name]" :binary="true" />
                    <label for="binary">{{$t(field.label)}}</label>
                </div>
                <span class="p-float-label m-3" v-else>
                    <InputText :id="field.name" type="text" v-if="field.type == 'string'" v-model="model[field.name]" />
                    <InputText :id="field.name" type="number" v-if="field.type == 'number'" v-model="model[field.name]" />
                    <GenericCustomSelect :field="field"
                        v-model="model[field.name]" 
                        :api="field.selectApi"
                        class="w-full"
                        v-if="field.type == 'select'" 
                        :format="field.selectFormat" />
                    <Calendar 
                        v-if="field.type == 'date'" 
                        v-model="model[field.name]" 
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        :dateFormat="field.format ?? constants.DATE_FORMAT"
                        :class="{ 'w-full': true}" />
                    <Calendar 
                        v-if="field.type == 'datetime'" 
                        :placeholder="constants.DATE_PLACEHOLDER_POINT"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="true" :hideOnDateTimeSelect="true"
                        v-model="model[field.name]"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        :class="{ 'w-full': true}" />
                    <label :for="field.name">{{$t(field.label)}}</label>
                </span>
            </div>
        </div>
        
        <template #footer>
            <Button :label="$t('btn.cancel')" icon="pi pi-times" @click="closeModal" class="p-button-text"/>
            <Button :label="$t(item.confirmBtnText)" icon="pi pi-check" @click="item.action(item.data, model, caller)" autofocus />
        </template>
    </Dialog>
</template>